module.exports = __webpack_public_path__ + "media/images/favicon-3f4093adf1431ea4a91ee95e8674f99d.png";